let areaArray = 	[
    {
        "id" : "c5312b5c-e22a-4a5c-867d-f31a3f95a0af",
        "name" : "黄浦区",
        "parent_id" : "16507f13-0ae3-4555-b46c-2df68e8b0957",
        "level_enum_code" : "Area",
        "center": "121.48,31.23",
        "sort" : 100100
    },
    {
        "id" : "05d5b87a-d8c6-47c5-b9b5-b634fed2e3e5",
        "name" : "静安区",
        "parent_id" : "16507f13-0ae3-4555-b46c-2df68e8b0957",
        "level_enum_code" : "Area",
        "center": "121.45,31.23",
        "sort" : 200400
    },
    {
        "id" : "d68e8ae1-7223-4164-8273-b95acb1a3e39",
        "name" : "徐汇区",
        "parent_id" : "16507f13-0ae3-4555-b46c-2df68e8b0957",
        "level_enum_code" : "Area",
        "center": "121.43,31.18",
        "sort" : 300200
    },
    {
        "id" : "f34349e4-dd4f-4bd0-9345-14456b30f8c9",
        "name" : "长宁区",
        "parent_id" : "16507f13-0ae3-4555-b46c-2df68e8b0957",
        "level_enum_code" : "Area",
        "center": "121.42,31.22",
        "sort" : 400300
    },
    {
        "id" : "04a4f4d2-0b95-45f6-a9b1-5b78216f4517",
        "name" : "虹口区",
        "parent_id" : "16507f13-0ae3-4555-b46c-2df68e8b0957",
        "level_enum_code" : "Area",
        "center": "121.48,31.23",
        "sort" : 500600
    },
    {
        "id" : "f2069769-cdb5-438a-a35b-2da2785c779f",
        "name" : "普陀区",
        "parent_id" : "16507f13-0ae3-4555-b46c-2df68e8b0957",
        "level_enum_code" : "Area",
        "center": "121.415827,31.238831",
        "sort" : 600500
    },
    {
        "id" : "7818c8f3-e249-49d9-a49f-bba70998006e",
        "name" : "杨浦区",
        "parent_id" : "16507f13-0ae3-4555-b46c-2df68e8b0957",
        "level_enum_code" : "Area",
        "center": "121.52,31.27",
        "sort" : 700700
    },
    {
        "id" : "13751cb6-8c65-45f1-ae7c-ad94382f7ba6",
        "name" : "浦东新区",
        "parent_id" : "16507f13-0ae3-4555-b46c-2df68e8b0957",
        "level_enum_code" : "Area",
        "center": "121.53,31.22",
        "sort" : 801100
    },
    {
        "id" : "c43a6c66-a3ef-4a53-b32b-8adb68e35e01",
        "name" : "闵行区",
        "parent_id" : "16507f13-0ae3-4555-b46c-2df68e8b0957",
        "level_enum_code" : "Area",
        "center": "121.38,31.12",
        "sort" : 900800
    },
    {
        "id" : "144b378e-4464-4508-be6d-5621099ed1df",
        "name" : "宝山区",
        "parent_id" : "16507f13-0ae3-4555-b46c-2df68e8b0957",
        "level_enum_code" : "Area",
        "center": "121.397241,31.41462",
        "sort" : 1000900
    },
    {
        "id" : "6bbab399-4fb8-4f22-a42d-67204f4b3a39",
        "name" : "嘉定区",
        "parent_id" : "16507f13-0ae3-4555-b46c-2df68e8b0957",
        "level_enum_code" : "Area",
        "center": "121.27,31.38",
        "sort" : 1101000
    },
    {
        "id" : "1b22785b-fdd1-4a58-a157-cf199cb46a01",
        "name" : "奉贤区",
        "parent_id" : "16507f13-0ae3-4555-b46c-2df68e8b0957",
        "level_enum_code" : "Area",
        "center": "121.47,30.92",
        "sort" : 1201500
    },
    {
        "id" : "620d7e3e-ce49-4877-981b-e8aa125c19aa",
        "name" : "金山区",
        "parent_id" : "16507f13-0ae3-4555-b46c-2df68e8b0957",
        "level_enum_code" : "Area",
        "center": "121.33,30.75",
        "sort" : 1301200
    },
    {
        "id" : "deb4559f-4006-4bcb-ac8e-c77e2e720686",
        "name" : "青浦区",
        "parent_id" : "16507f13-0ae3-4555-b46c-2df68e8b0957",
        "level_enum_code" : "Area",
        "center": "121.12,31.15",
        "sort" : 1401400
    },
    {
        "id" : "1861351f-42df-423e-9bfc-54122f2aa01f",
        "name" : "松江区",
        "parent_id" : "16507f13-0ae3-4555-b46c-2df68e8b0957",
        "level_enum_code" : "Area",
        "center": "121.22,31.03",
        "sort" : 1501300
    },
    {
        "id" : "adb28c80-6682-42c1-a356-d66b467dd139",
        "name" : "崇明区",
        "parent_id" : "16507f13-0ae3-4555-b46c-2df68e8b0957",
        "level_enum_code" : "Area",
        "center": "121.4,31.62",
        "sort" : 1601600
    }
]
export default areaArray;
